<template>
  <div id="view-login">
    <div>
      <div id="logo" @click="goHome" />
    </div>

    <sui-grid class="middle aligned center aligned">
      <br>
      <sui-container text-align="left">
        <h2 as="sui-header" align="center" inverted>{{ $t('pleaseLogin') }}:</h2>
        <sui-segment class="smallSegment">
          <sui-form @submit="clickLogin">
            <sui-form-field :error="errorUsername">
              <label></label>
              <sui-input icon-position="left" icon="user" name="username" type="text" :placeholder="$t('username')" v-model="current.username" />
              <sui-message error :visible="errorUsername">
                <p>{{ $t('username') }} {{ $t('errorEmpty') }}</p>
              </sui-message>
            </sui-form-field>
            <sui-form-field :error="errorPassword">
              <label></label>
              <sui-input icon-position="left" icon="lock" name="password" type="password" :placeholder="$t('password')" v-model="current.password" />
              <sui-message error :visible="errorPassword">
                <p>{{ $t('password') }} {{ $t('errorEmpty') }}</p>
              </sui-message>
            </sui-form-field>
            <sui-button @click.prevent="clickLogin" color="red" fluid>{{ $t('login') }}</sui-button>
          </sui-form>

          <sui-message error v-if="error">
            {{ error }}
          </sui-message>

          <sui-dimmer :active="loading">
            <sui-loader>{{ $t('loading') }}</sui-loader>
          </sui-dimmer>
        </sui-segment>

        <sui-segment class="smallSegment" style="text-align:center">
          <!-- {{$t('newHere')}} <router-link to="/register">{{$t('gotoRegister')}}</router-link><br> -->
          {{$t('forgotPass')}} <router-link to="/forgotPass">{{$t("gotoForgotpass")}}</router-link>
          
        </sui-segment>
      </sui-container>
    </sui-grid>

  </div>
</template>

<script>
  import ApiService from '@/services/ApiService.js';

  export default {
    name: 'Login',
    data() {
      return {
        loading: false,
        error: '',
        errorUsername: false,
        errorUsernameMsg: '',
        errorPassword: false,
        errorPasswordMsg: '',
        result: {
          valid: false,
          voucherPlus: false,
          tarif: '',
          timeLeft: 0,
          dataLeft: 0,
          min: '',
          max: ''
        },
        current: {
          username: '',
          password: ''
        }
      }
    },
    async created() {
      if (this.$store.getters.isLoggedIn) {
        this.$router.push('/');
      }
    },
    methods: {
      goHome() {
        this.$router.push('/')
      },
      async clickLogin() {
        this.loading = true
        this.errorUsername = !(this.current.username && this.current.username.length > 0)
        this.errorUsernameMsg = this.errorUsername ? this.$t('username') + ' ' + this.$t('errorEmpty') : ''
        this.errorPassword = !(this.current.password && this.current.password.length > 0)
        this.errorPasswordMsg = this.errorPassword ? this.$t('password') + ' ' + this.$t('errorEmpty') : ''

        if (this.errorUsername == false && this.errorPassword == false) {
          let response = await ApiService.postLogin({
            email: this.current.username,
            password: this.current.password
          });
          this.loading = false
          if (response.status == 200) {
            if(response.data.access_token != null){
            let token = response.data.access_token;
            let user = response.data.user;
            this.$store.dispatch('doLogin', { user, token });
            this.$router.push('/');
            }else{
              this.$swal(this.$t("error"), this.$t("errorBanned"), "error");
            }
          } else {
            response.data.error != null ? this.$swal(this.$t('error'), this.$t(response.data.error), 'error') : this.$swal(this.$t('error'), this.$t('errorMailOrPass'), 'error')
          }
        } else {
          this.loading = false
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  h2 {
    color: #fff;
  }
  #logo {
    background-image: url(https://cdn.lan1.eu/logos/lan1_logo_color.png);
    background-repeat: no-repeat;
    background-size: 140px 63px;
    height: 71px;
    left: 5px;
    margin: 10px auto;
    position: relative;
    top: 5px;
    width: 858px;
    cursor: pointer;
  }

  #banner {
    background-image: url(../assets/img/banner_online.png);
    width: 477px;
    height: 156px;
    background-repeat: no-repeat;
    margin: 0 auto 1em;
    position: relative;
    top: 0px;
  }
  .smallSegment {
    max-width: 450px;
    margin: 0 auto 10px !important;
  }
  #view-login{
    overflow-x: hidden;
    overflow-y: hidden;
  }
</style>
